import React from "react";
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";

import "./AvvenutoPagamentoCase.scss";

const AvvenutoPagamentoCase = () => {
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  return (
    <div className="AvvenutoPagamentoCase" data-testid="AvvenutoPagamentoCase">
      <CaseGenerator
        type={CaseForms.AvvenutoPagamento}
        initialValues={
          {...profile,
           ...((profile.role === UserRoleEnum.PRIVATE || profile.businessName==='') && { businessName: `${profile.name} ${profile.surname}` }),
          }
         }
      />
    </div>
  );
};

export default AvvenutoPagamentoCase;
